module.exports = __webpack_public_path__ + "img/door-held-open.dc8bae87.svg";